import { useState } from 'react';

export default (windowLocation: string) => {
  const [showCopied, setShowCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(windowLocation);
    setShowCopied(true);
    setTimeout(() => setShowCopied(false), 1500); // Show "Copied!" for 1.5 seconds
  };
  
  return {
    showCopied,
    handleCopy,
  };
};
